// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ja-c";
export var backButton = "_ja-4";
export var backIcon = "_ja-5";
export var chevronShortcut = "_ja-6";
export var container = "_ja-1";
export var editor = "_ja-8";
export var editorWrapper = "_ja-7";
export var prefix = "_ja-2";
export var searchIcon = "_ja-3";
export var suffix = "_ja-9";
export var suffixContent = "_ja-a";
export var suffixText = "_ja-b";
export var wrapper = "_ja-0";